import React from 'react';

function STWDeluxeStatItem({data, index}) {
  const className = index % 2 === 0 ? 'stat-item light' : 'stat-item';
  const iconBaseURL = process.env.PUBLIC_URL + './assets/players/deluxe/';
  const scores = data['scores'].split(' ');

  const getFormattedData = () => {
    return new Date(data['date'] * 1000).toLocaleString('en-GB').replace(',', '');
  }

  return <div className={className}>
    <div className="result-info">
      <p className="info">ID: {data['game_id']}</p>
      <div className='info'>
        <img src={iconBaseURL + scores[2] + '.png'} alt='' key={index}/>
        <b style={{color: scores[1], fontSize: '1vw'}}>{scores[0]}</b>
      </div>
    </div>
    <div className="date-info">
      {getFormattedData()}
    </div>
  </div>
}

export default STWDeluxeStatItem;